// extracted by mini-css-extract-plugin
export var active = "_11-9";
export var backButton = "_11-8";
export var clone = "_11-e";
export var collapseBar = "_11-k";
export var collapseMode = "_11-m";
export var collapsed = "_11-o";
export var dimmed = "_11-i";
export var dragHandle = "_11-c";
export var dropdownIcon = "_11-g";
export var expanding = "_11-n";
export var hidden = "_11-x";
export var iconContainer = "_11-q";
export var iconSwapper = "_11-w";
export var navItem = "_11-6";
export var navItemIcon = "_11-f";
export var navProfile = "_11-7";
export var notificationCountBadge = "_11-j";
export var notificationDot = "_11-r";
export var optionsContainer = "_11-h";
export var primaryNav = "_11-0";
export var primaryNavDivider = "_11-v";
export var primaryNavResizeHandle = "_11-2";
export var primaryNavResizing = "_11-1";
export var primaryNavTabSection = "_11-u";
export var primaryTab = "_11-p";
export var primaryTabIconBox = "_11-s";
export var secondaryNav = "_11-3";
export var selected = "_11-t";
export var settingsNav = "_11-4";
export var settingsNavItems = "_11-5";
export var show = "_11-d";
export var sideNav = "_11-l";
export var teamItem = "_11-a";
export var userProfileItem = "_11-b";